module.exports = __webpack_public_path__ + "img/step5.11.4826aee6.png";